/**
 * loadingMap / errorMap keys for the Smart photos (bulk image analysis v2) slice.
 *
 * In their own module, with no imports of their own, purely to keep
 * BulkImageAnalysisV2Db and BulkImageAnalysisV2Thunk out of a circular import:
 * the slice needs the thunks at module-evaluation time, and components / hooks
 * need these keys. Same reason as CatalogImportKeys.ts. The slice re-exports them.
 *
 * Per-session operations key by session id so acting on one session never
 * disables another.
 */

export const BIA_CONFIG_KEY = "fetchBiaConfig";
/** Create session: one create runs at a time. */
export const BIA_CREATE_KEY = "createBiaSession";

export const biaListKey = (businessId: string): string => `fetchBiaSessions_${businessId}`;
export const biaSessionKey = (sessionId: string): string => `fetchBiaSession_${sessionId}`;
export const biaImagesKey = (sessionId: string): string => `fetchBiaImages_${sessionId}`;
export const biaPlanKey = (sessionId: string): string => `fetchBiaPlan_${sessionId}`;
export const biaVersionsKey = (sessionId: string): string => `fetchBiaPlanVersions_${sessionId}`;
export const biaExportKey = (sessionId: string): string => `exportBiaPlan_${sessionId}`;
export const biaPayloadKey = (sessionId: string): string => `fetchBiaPayload_${sessionId}`;
export const biaCreateProductsKey = (sessionId: string): string => `createBiaProducts_${sessionId}`;
/** Exclude / include / delete of one photo. */
export const biaImageActionKey = (imageId: string): string => `biaImageAction_${imageId}`;

/** The session-level actions that change its state (one "busy" flag each, so a banner can say which one failed). */
export type BiaAction =
  | "update"
  | "cancel"
  | "plan"
  | "revise"
  | "save"
  | "restore"
  | "confirm"
  | "unconfirm"
  | "generate"
  | "retry"
  | "finish";

export const biaActionKey = (sessionId: string, action: BiaAction): string => `biaAction_${action}_${sessionId}`;
